import FormControlLabel from '@mui/material/FormControlLabel';
import React, { FC } from 'react';
import { ConstantsCodeType } from 'src/types/constantsCodes';
import Tabs from '../Tabs';

export interface TabsInputPropsType {
    label?: string;
    options: ConstantsCodeType[];
    selected?: string;
    onChange?: (value: string) => void;
    value?: string;
    disabled?: boolean;
    disabledItems?: string[];
}

const TabsInput: FC<TabsInputPropsType> = (props) => {
    return (
        <>
            <FormControlLabel
                value="start"
                control={<span></span>}
                label={props.label}
                labelPlacement="top"
                className="input-switch"
                disabled={props.disabled}
            />
            <Tabs
                items={props.options.map((option) => ({ label: option.label, value: String(option.value) }))}
                selected={String(props.value)}
                onChange={(value) => props.onChange && props.onChange(value)}
                disabled={props.disabled}
                disabledItems={props.disabledItems}
            />
        </>
    );
};

export default TabsInput;
